module.exports = __webpack_public_path__ + "img/knu_main2.41338287.jpg";